module.exports = __webpack_public_path__ + "img/Comic02-2.414ed12d.png";